import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthLayout } from "@/shared/layout";
import { useAuth } from "@/shared/contexts/AuthContext";

const Logout: React.FC = () => {
	const navigate = useNavigate();
	const { logout } = useAuth();

	useEffect(() => {
		// Perform logout when component mounts
		const performLogout = () => {
			logout();
			// Redirect to login after a short delay
			setTimeout(() => {
				navigate("/login");
			}, 2000);
		};

		performLogout();
	}, [navigate, logout]);

	return (
		<AuthLayout title="Logging out..." subtitle="You are being logged out securely">
			<div style={{ textAlign: "center", padding: "2rem 0" }}>
				<h2>Goodbye!</h2>
				<p>You will be redirected to the login page shortly.</p>
			</div>
		</AuthLayout>
	);
};

export default Logout;
